import { atom } from 'recoil';

export const refreshMissingInformationAtom = atom<object>({
    key: 'refreshMissingInformation',
    default: {}
});
